import { PureComponent } from 'react';
import './styles';

export default class Icon extends PureComponent<IProps> {

    public render() {
        const props = this.props;
        const base = props.base || 80;

        return (
            <span className={('jc-icon ' + (props.className || '')).trim()}>
                <svg viewBox={props.viewBox || '0 0 ' + base + ' ' + base}>
                    {props.children}
                </svg>
            </span>
        );
    }
}

export interface IProps extends React.HTMLProps<Icon> {
    base?: number;
    viewBox?: string;
}
